import React from "react";
import { Home, Handshake, KeyRound, ClipboardCheck, ArrowUpRight } from "lucide-react";
import { services } from "../mock";
import useReveal from "../hooks/useReveal";

const iconMap = { Home, Handshake, KeyRound, ClipboardCheck };

function ServiceCard({ s, i }) {
  const [ref, inView] = useReveal();
  const Icon = iconMap[s.icon];
  return (
    <div
      ref={ref}
      className={`service-card group bg-card border border-border rounded-2xl p-8 hover:shadow-xl hover:border-accent/40 reveal ${
        inView ? "in-view" : ""
      }`}
      style={{ animationDelay: `${i * 0.12}s` }}
    >
      <div className="flex items-center justify-center h-14 w-14 rounded-xl bg-primary/10 text-primary group-hover:bg-accent group-hover:text-accent-foreground transition-colors duration-300">
        <Icon className="h-7 w-7" strokeWidth={1.6} />
      </div>
      <h3 className="font-serif text-2xl font-semibold mt-6 mb-3 text-foreground">{s.title}</h3>
      <p className="text-muted-foreground leading-relaxed text-[15px]">{s.text}</p>
      <div className="flex items-center gap-1.5 mt-5 text-accent text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
        En savoir plus <ArrowUpRight className="h-4 w-4" />
      </div>
    </div>
  );
}

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="eyebrow-line text-accent tracking-[0.3em] text-xs font-medium uppercase">
            Nos expertises
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-5 text-foreground">
            Un accompagnement complet
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Quatre métiers, une seule exigence : votre satisfaction à chaque étape de votre projet immobilier.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <ServiceCard key={s.id} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
